module.exports = __webpack_public_path__ + "img/plateau_nenuphar.6ec8de1d.jpg";